webpackJsonp([147769348217237],{

/***/ 2056:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TreatmentSheetCellComment","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"datetime","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"provider","type":{"kind":"OBJECT","name":"Provider","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"text","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-treatment-sheet-cell-comment-66c11c576806ee2510d5.js